import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import Typography, { TypographyProps } from "@material-ui/core/Typography";
import React from "react";
import { HERO_TITLE_ID_CONTAINER } from "../../../../constants";
import { ColorTypes, useWidgetTextColorFromType } from "../hooks";

const styles: StyleRulesCallback = ({ breakpoints, typography, spacing: { unit } }) => ({
  root: {
    fontWeight: typography.fontWeightMedium,
    lineHeight: `${unit * 6}px`,
    marginBottom: unit,
    [breakpoints.down("md")]: {
      lineHeight: `${unit * 5}px`
    }
  }
});

type TitleProps = TypographyProps & WithStyles<typeof styles> & { colorType?: ColorTypes };

const BaseTitle: React.FC<TitleProps> = ({ classes, children, colorType, ...props }) => {
  const colorStyle = useWidgetTextColorFromType(colorType);
  return (
    <Typography
      variant="h4"
      component="h1"
      color="inherit"
      classes={classes}
      style={colorStyle}
      {...props}
      data-id={HERO_TITLE_ID_CONTAINER}
    >
      {children}
    </Typography>
  );
};

export const Title = withStyles(styles)(BaseTitle);
